// js for shopable video
class ShopableVideo extends PopupBase {
  constructor() {
    super();
    this.popupDiv = this.querySelector(".video-item__popup");
    this.init();
  }
  init() {
    if (this.popupDiv || !this.classList.contains("instagram-item")) {
      window.addEventListener("resize", this.responsive.bind(this));
      window.addEventListener("load", this.responsive.bind(this));
      this.addEventListener("click", this.onClick.bind(this));
      this.connectedCallback();
    }
  }
  onClick() {
    const template = this.closest(".shopable-video-section").querySelector(
      "template"
    );
    if (template) {
      let content =
        template.content.firstElementChild.cloneNode(true);
      
      // Fix slide count issue
      content.setAttribute("data-mobile", "1");
      content = content.outerHTML;

      const navPrev = `<div class="swiper-arrow swiper-prev-modal transition swiper-button-prev bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>
          </div>`;
      const navNext = `<div class="swiper-arrow swiper-next-modal transition swiper-button-next bg-white btn-hover inline-flex content-center border rounded-50 overflow-hidden">
            <svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>
          </div>`;
      this.initPopup(navPrev + content + navNext);
      this.findActiveSlideModal();
      const modal = this.modal;
      if (!modal) return;
      const productPopupDiv = modal.modalBoxContent.querySelectorAll(
        ".video-item__product-mobile"
      );
      if (productPopupDiv.length > 0){
        productPopupDiv.forEach((div) => {
          div.addEventListener(
            "click",
            this.onClickMobile.bind(this)
          );
        });
      }

      // Add click to play/pause on the videos
      const popupVideos = modal.modalBoxContent.querySelectorAll(".video-item__popup-media--ratio video");
      popupVideos.forEach((video) => {
        video.addEventListener("click", () => {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      });

      // Mute button logic
      const muteButtons = modal.modalBoxContent.querySelectorAll(".custom-mute-btn");
      muteButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const video = btn.parentElement.querySelector("video");
          if (!video) return;
          const iconMute = btn.querySelector(".icon-mute");
          const iconUnmute = btn.querySelector(".icon-unmute");
          if (video.muted) {
            video.muted = false;
            iconMute.classList.remove("hidden");
            iconUnmute.classList.add("hidden");
          } else {
            video.muted = true;
            iconMute.classList.add("hidden");
            iconUnmute.classList.remove("hidden");
          }
        });
      });
    }
  }

  findActiveSlideModal() {
    const modal = this.modal;
    if (!modal) return;
    const swiperContainer = modal.modalBoxContent.querySelector(
      "slide-section-popup"
    );
    if (!swiperContainer || !swiperContainer.swiper) return;
    
    // Force Swiper to recalculate dimensions since it initializes while modal is display:none
    setTimeout(() => {
      swiperContainer.swiper.update();
    }, 150);

    const position = this.dataset.position;
    if (!position) return;
    if (position !== null && !isNaN(parseInt(position))) {
      const slideIndex = parseInt(position);
      swiperContainer.swiper.slideTo(slideIndex, 0, false);
    } else {
      swiperContainer.swiper.slideTo(0, 0, false);
    }

    setTimeout(() => {
      const activeSlide = swiperContainer.swiper.slides[swiperContainer.swiper.activeIndex];
      if (activeSlide) {
        const video = activeSlide.querySelector("video");
        if (video) {
          video.currentTime = 0;
          video.play().catch(e => {
            // Autoplay policy prevents unmuted autoplay on some browsers, fallback to muted autoplay
            video.muted = true;
            video.play();
            const btn = activeSlide.querySelector(".custom-mute-btn");
            if (btn) {
              btn.querySelector(".icon-mute").classList.add("hidden");
              btn.querySelector(".icon-unmute").classList.remove("hidden");
            }
          });
        }
      }
    }, 50);
  }

  onCloseEvent() {
    const popup = document.querySelector(".tingle-modal.shopable-video");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    productInformation.classList.add("hidden");
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const videos = this.querySelectorAll("video");
      videos.forEach((video) => {
        const dataSrc = video.dataset.src;
        if (dataSrc) {
          video.src = dataSrc;
          video.removeAttribute("data-src");
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }
  responsive() {
    const productDivs = document.querySelectorAll(
      ".shopable-video__product-information"
    );
    if (productDivs.length != 0) {
      if (window.innerWidth >= 768) {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.remove("hidden");
        });
      } else {
        const flexDiv = this.popupDiv?.querySelector(
          ".video-item__popup--flex"
        );
        if (!flexDiv) return;
        productDivs.forEach((div) => {
          div.classList.add("hidden");
        });
      }
    }
  }
  onClickMobile(event) {
    const _this = this;
    const currentTarget = event.currentTarget;
    const popup = currentTarget.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = false;
    slidePopup.swiper.unsetGrabCursor();
    productInformation.classList.remove("hidden");
    popup.classList.add("open");
    _this.modal.modalCloseBtn.style.display = "none";
  }
}
customElements.define("shopable-video", ShopableVideo);

class SlideSectionPopup extends SlideSection {
  constructor() {
    super();
  }
  
  initSlide() {
    if (window.innerWidth < 768) {
      this.dataset.direction = "vertical";
    } else {
      this.dataset.direction = "horizontal";
    }
    
    super.initSlide();
    if (this.globalSlide) {
      this.globalSlide.on('slideChange', () => {
        if (typeof pauseAllMedia === 'function') {
          pauseAllMedia();
        } else {
          document.querySelectorAll("video").forEach((video) => {
            if (typeof video.pause === 'function') video.pause();
          });
        }
        
        const activeSlide = this.globalSlide.slides[this.globalSlide.activeIndex];
        if (activeSlide) {
          const video = activeSlide.querySelector("video");
          if (video && typeof video.play === 'function') {
            video.currentTime = 0;
            video.muted = false;
            video.play();
          }
        }
      });
    }
  }
}
customElements.define("slide-section-popup", SlideSectionPopup);

class ShopableOverlay extends ShopableVideo {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    const currentTarget = event.currentTarget;
    const modal = currentTarget.closest(".shopable-video");
    const popup = currentTarget?.closest(".video-item__popup");
    if (!popup) return;
    const productInformation = popup.querySelector(
      ".shopable-video__product-information"
    );
    const modalCloseBtn = modal?.querySelector(".tingle-modal__close");
    if (!productInformation) return;
    const slidePopup = document.querySelector("slide-section-popup");
    slidePopup.swiper.allowTouchMove = true;
    slidePopup.swiper.setGrabCursor();
    productInformation.classList.add("hidden");
    popup.classList.remove("open");
    modalCloseBtn.removeAttribute("style");
  }
}
customElements.define("shopable-overlay", ShopableOverlay);

class ButtonCloseShopable extends ShopableOverlay {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }
}
customElements.define("button-close-shopable", ButtonCloseShopable);